<p-dialog
  [(visible)]="dialogVisible"
  [header]="'select.devices' | transloco"
  [style]="{ width: '90vw' }"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  (onHide)="visibleChange.emit(false)"
  appendTo="body"
>
  <div *ngIf="dialogVisible">
    <app-devices-step
      [(deviceSelection)]="deviceSelection"
      [(deviceFilters)]="deviceFilters"
      [tenant]="tenant"
      [organization]="organization"
      [selectionMode]="selectionMode"
    ></app-devices-step>
  </div>

  <div class="flex justify-content-between pt-4">
    <button
      [label]="'common.cancel' | transloco"
      (click)="closeWithoutSaving()"
      pButton
      class="mr-2 p-button-danger"
    ></button>
    <div>
      <button
        *ngFor="let actionButton of actionButtons"
        [label]="actionButton.label | transloco"
        (click)="actionButton.action(deviceSelection)"
        [disabled]="!deviceSelection || deviceSelection.length === 0"
        [icon]="actionButton.icon"
        pButton
        icon="pi pi-check"
        iconPos="right"
        class="ml-2"
      ></button>
    </div>
  </div>
</p-dialog>
